import { render } from "./MenuMinimized.vue?vue&type=template&id=38368658&scoped=true"
import script from "./MenuMinimized.vue?vue&type=script&lang=js"
export * from "./MenuMinimized.vue?vue&type=script&lang=js"

import "./MenuMinimized.vue?vue&type=style&index=0&id=38368658&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38368658"]])

export default __exports__